import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList
} from 'graphql'
import {
  ApplicationFilterArgType,
  ApplicationFilterArg
} from './application-filter-arg'

export interface ApplicationFilterMutationArgs {
  readonly input: {
    readonly organizationID: string
    readonly excludedApplications: string[]
    readonly filters: ApplicationFilterArg
  }
}

export const applicationFilterMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ApplicationFilterMutationArg',
      description:
        'Mutation input type for updating applications based on a set of filters.',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that owns the applications being mutated.',
          type: new GraphQLNonNull(GraphQLID)
        },
        excludedApplications: {
          description:
            'A list of application IDs to exclude from the mutation.',
          type: new GraphQLNonNull(new GraphQLList(GraphQLID))
        },
        filters: {
          description:
            'A collection of filters to specify which applications the mutation should apply to.',
          type: new GraphQLNonNull(ApplicationFilterArgType)
        }
      })
    })
  }
}
